import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function CompetitiveEdge() {
  const edges = ['Verified practitioner network', 'Women-first wellness focus', 'AI-powered personalization', 'Holistic + clinical integration', 'Community + marketplace hybrid'];
  return <Section background="charcoal" className="text-ivory" data-id="element-144" data-mp="15c6mk0hgq9vw">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-145" data-mp="15an546k2lssj">
        <div data-id="element-146" data-mp="10c24i60wp73k">
          <FadeIn data-id="element-147" data-mp="10cbwu09fbqcf">
            <h2 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-148" data-mp="10cu37ppsvky2">
              Where Trust Meets{' '}
              <span className="italic text-purple-700" data-id="element-149" data-mp="1easdaix38v7r">Intelligence</span>
            </h2>
            <p className="text-lg text-ivory/70 mb-8" data-id="element-150" data-mp="19el4midb55m4">
              We are not just another directory. We are a curated, intelligent
              infrastructure designed specifically for the nuances of women's
              health.
            </p>
          </FadeIn>
        </div>

        <div data-id="element-151" data-mp="3l5pgk73o369v">
          <div className="space-y-6" data-id="element-152" data-mp="3l67ow23ltay5">
            {edges.map((edge, idx) => <FadeIn key={idx} delay={idx * 150} data-id="element-153" data-mp="3q497yn115a9m" data-mpi={idx}>
                <div className="flex items-center p-4 rounded-xl bg-white/5 border border-white/10 backdrop-blur-sm" data-id="element-154" data-mp="3v2khewnexirb">
                  <CheckCircle2 className="w-6 h-6 text-purple-400 mr-4 flex-shrink-0" data-id="element-155" data-mp="3oeqytucitdm" />
                  <span className="text-lg font-medium tracking-wide" data-id="element-156" data-mp="7pqfew1hh8k8">
                    {edge}
                  </span>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </Section>;
}